module.exports = "/templates/bds/public/images/98b28642485021b6726d18ad86f8388e.gif";